<template>
  <div>
    <!-- Card principal del mapa -->
    <!-- <div class="card card-primary card-outline">
      <div class="card-header">
        <h3 class="card-title">
          <i class="fas fa-map-marked-alt mr-2"></i>
          Mapa de Trazabilidad del Viaje
        </h3>
      </div> -->
      <div class="card-body">
        <!-- Barra de herramientas -->
        <div class="row mb-3">
          <div class="col-12">
            <div class="btn-toolbar justify-content-start" role="toolbar">
              <!-- Grupo de controles de trazabilidad -->
              <div class="btn-group mr-2 mb-2" role="group">
                <button
                  type="button"
                  class="btn"
                  :class="form.traza ? 'btn-primary' : 'btn-outline-primary'"
                  @click="toggleTraza()"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Activar/Desactivar Traza del Viaje"
                >
                  <i class="fas fa-map-marked-alt mr-1"></i>
                  <span class="d-none d-md-inline">Traza Viaje</span>
                  <span
                    v-if="form.traza"
                    class="badge badge-light ml-1"
                  >ON</span>
                </button>
              </div>
              
              <!-- Grupo de controles de novedades -->
              <div class="btn-group mr-2 mb-2" role="group">
                <button
                  type="button"
                  class="btn"
                  :class="form.novedades ? 'btn-warning' : 'btn-outline-warning'"
                  @click="toggleNovedades()"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Activar/Desactivar Novedades en el Mapa"
                >
                  <i class="fas fa-exclamation-triangle mr-1"></i>
                  <span class="d-none d-md-inline">Novedades</span>
                  <span
                    v-if="form.novedades"
                    class="badge badge-light ml-1"
                  >ON</span>
                </button>
              </div>
              
              <!-- Grupo de controles de geocercas -->
              <div class="btn-group mr-2 mb-2" role="group">
                <button
                  type="button"
                  class="btn"
                  :class="form.geocercas ? 'btn-info' : 'btn-outline-info'"
                  @click="toggleGeocercas()"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Activar/Desactivar Geocercas en el Mapa"
                >
                  <i class="fas fa-draw-polygon mr-1"></i>
                  <span class="d-none d-md-inline">Geocercas</span>
                  <span
                    v-if="form.geocercas"
                    class="badge badge-light ml-1"
                  >ON</span>
                </button>
              </div>
              <div
                class="btn-group mr-2 mb-2"
                role="group"
              >
                <button
                  type="button"
                  class="btn"
                  :class="form.rutaGeocercas ? 'btn-secondary' : 'btn-outline-secondary'"
                  @click="toggleRutaGeocercas()"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Dibujar Ruta del Viaje y Geocercas Asociadas"
                >
                  <i class="fas fa-route mr-1"></i>
                  <span class="d-none d-md-inline">Ruta</span>
                  <span
                    v-if="form.rutaGeocercas"
                    class="badge badge-light ml-1"
                  >ON</span>
                </button>
              </div>
              
              <!-- Botón de exportar -->
              <div class="btn-group mb-2" role="group">
                <button
                  type="button"
                  class="btn btn-success"
                  @click="generarListadoExcel()"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Exportar Trazabilidad a Excel"
                >
                  <i class="far fa-file-excel mr-1"></i>
                  <span class="d-none d-md-inline">Exportar Excel</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Leyenda de marcadores -->
        <div class="row mb-3">
          <div class="col-12">
            <div class="card card-outline card-info">
              <div class="card-body p-2">
                <div class="row text-center">
                  <div class="col-md-3 col-6 mb-2">
                    <small>
                      <i class="fas fa-circle text-success mr-1"></i>
                      <strong>Punto Inicial</strong>
                    </small>
                  </div>
                  <div class="col-md-3 col-6 mb-2">
                    <small>
                      <i class="fas fa-circle text-primary mr-1"></i>
                      <strong>Punto Final</strong>
                    </small>
                  </div>
                  <div class="col-md-3 col-6 mb-2">
                    <small>
                      <i class="fas fa-exclamation-triangle text-warning mr-1"></i>
                      <strong>Advertencias</strong>
                    </small>
                  </div>
                  <div class="col-md-3 col-6 mb-2">
                    <small>
                      <i class="fas fa-exclamation-circle text-danger mr-1"></i>
                      <strong>Emergencias</strong>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mapa -->
        <div class="row">
          <div class="col-12">
            <div class="map-container" style="position: relative; border-radius: 4px; overflow: hidden; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
              <gmap-map
                ref="mapRef"
                :center="center"
                :zoom="zoomMapa"
                style="width: 100%; height: 500px"
              >
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :icon="m.icon"
          :animation="2"
          @click="toggleInfoWindow(m, index, m.info)"
        ></gmap-marker>
        <gmap-marker
          :key="index"
          v-for="(m, index) in markersAd"
          :position="m.position"
          :icon="m.icon"
          :animation="2"
          @click="toggleInfoWindow(m, index, m.info)"
        ></gmap-marker>
        <gmap-marker
          :key="index"
          v-for="(m, index) in markersEm"
          :position="m.position"
          :icon="m.icon"
          :animation="2"
          @click="toggleInfoWindow(m, index, m.info)"
        ></gmap-marker>
        <gmap-info-window
          :options="infoOptions"
          :position="infoWindowPos"
          :opened="infoWinOpen"
          @closeclick="infoWinOpen = false"
        >
          <div v-html="infoContent"></div>
        </gmap-info-window>
        <gmap-polygon
          :options="{ fillColor: '#FF0000' }"
          v-for="poligono in poligonos"
          :key="poligono.id"
          :paths="poligono.path"
          :editable="false"
          :draggable="false"
          @click="toggleInfoWindowPoli(poligono, poligono.id, poligono.info)"
        />
        <gmap-circle
          v-for="circular in circunferencias"
          :key="circular.id"
          :center="circular.center"
          :radius="circular.radius"
          :info="circular.info"
          @click="toggleInfoWindowCir(circular, circular.id, circular.info)"
        ></gmap-circle>
        <gmap-polyline
          v-if="pathRuta.length > 0"
          :options="polylineOptions"
          :path="pathRuta"
          :editable="false"
          ref="polyline"
        >
        </gmap-polyline>
        <gmap-polyline
          v-for="(polyline, id) in polylinesRuta"
          :key="'ruta-tramo-' + id"
          :path="polyline.path"
          :options="polyline.options"
          :editable="false"
          @click="
            toggleInfoWindowPoli(
              polyline,
              id,
              polyline.info != null ? polyline.info : ''
            )
          "
        ></gmap-polyline>
              </gmap-map>
            </div>
          </div>
        </div>
        
        <!-- Mensaje informativo -->
        <div class="row mt-3">
          <div class="col-12">
            <div class="text-muted text-left">
              <small>
                <i class="fas fa-info-circle mr-1"></i>
                Haz clic en los marcadores para ver más información
              </small>
            </div>
          </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import axios from "axios";
import { getRotacionFlechaTraza } from "@/utils/trazaGps";
export default {
  name: "Mapas",

  data() {
    return {
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      form: {
        geocercas: false,
        traza: false,
        novedades: false,
        rutaGeocercas: false,
      },
      polylineOptions: {
        strokeColor: "#ff1c79",
        strokeOpacity: "0.7",
        strokeWeight: 8,
      },
      centroBogota: { lat: 4.651371, lng: -74.071509 },
      center: { lat: 4.651371, lng: -74.071509 },
      zoomMapa: 12,
      markers: [],
      markersAd: [],
      markersEm: [],
      pathRuta: [],
      pathPoli: [],
      polylinesRuta: {},
      places: [],
      currentPlace: null,
      locations: {},
      poligonos: [],
      circunferencias: [],
      puntoInicialLat: null,
      puntoInicialLng: null,
      puntoFinalLat: null,
      puntoFinalLng: null,
      infoPuntoFinal: "",
      infoPuntoInicial: "",
      puntofin: null,
      vehiculo_id: null,
      latitud: null,
      longitud: null,
      puntosTraza: [],
      path: [],
    };
  },

  methods: {
    centrarBogota() {
      this.center = {
        lat: this.centroBogota.lat,
        lng: this.centroBogota.lng,
      };
      this.zoomMapa = 12;
      const mapRef = this.$refs.mapRef;
      if (mapRef && mapRef.$mapObject) {
        mapRef.$mapObject.setCenter(this.center);
        mapRef.$mapObject.setZoom(this.zoomMapa);
      }
    },

    // Función para crear icono de advertencia (amarillo) - fas fa-exclamation-triangle
    crearIconoAdvertencia() {
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r="22" fill="#ffc107" stroke="#fff" stroke-width="2"/>
          <path d="M24 8 L8 38 L40 38 Z" fill="#fff" opacity="0.2"/>
          <path d="M24 8 L8 38 L40 38 Z" fill="none" stroke="#000" stroke-width="2" stroke-linejoin="round"/>
          <path d="M24 18 L24 28 M24 30 L24 32" stroke="#000" stroke-width="3" stroke-linecap="round"/>
        </svg>
      `;
      // eslint-disable-next-line no-undef
      return {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
        // eslint-disable-next-line no-undef
        scaledSize: new google.maps.Size(48, 48),
        // eslint-disable-next-line no-undef
        anchor: new google.maps.Point(24, 48),
      };
    },

    // Función para crear icono de emergencia (rojo) - fas fa-exclamation-circle
    crearIconoEmergencia() {
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r="22" fill="#dc3545" stroke="#fff" stroke-width="2"/>
          <circle cx="24" cy="24" r="16" fill="none" stroke="#fff" stroke-width="1.5" opacity="0.3"/>
          <path d="M24 14 L24 26 M24 28 L24 30" stroke="#fff" stroke-width="3" stroke-linecap="round"/>
        </svg>
      `;
      // eslint-disable-next-line no-undef
      return {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
        // eslint-disable-next-line no-undef
        scaledSize: new google.maps.Size(48, 48),
        // eslint-disable-next-line no-undef
        anchor: new google.maps.Point(24, 48),
      };
    },

    toggleTraza() {
      this.form.traza = !this.form.traza;
      this.getTrazabilidad();
    },
    
    toggleNovedades() {
      this.form.novedades = !this.form.novedades;
      this.getNovedades();
    },
    
    toggleGeocercas() {
      this.form.geocercas = !this.form.geocercas;
      this.getGeocercas();
    },

    toggleRutaGeocercas() {
      this.form.rutaGeocercas = !this.form.rutaGeocercas;
      this.getRutaGeocercas();
    },
    
    limpiarCapasMapa() {
      this.markers = [];
      this.markersAd = [];
      this.markersEm = [];
      this.puntosTraza = [];
      this.pathRuta = [];
      this.pathPoli = [];
      this.polylinesRuta = {};
      this.path = [];
      this.poligonos = [];
      this.circunferencias = [];
      this.infoWinOpen = false;
      this.infoContent = "";
      this.currentMidx = null;
      this.centrarBogota();
    },

    limpiarMapa() {
      this.limpiarCapasMapa();
      this.form.geocercas = false;
      this.form.traza = false;
      this.form.novedades = false;
      this.form.rutaGeocercas = false;
    },

    async getTrazabilidad() {
      this.puntosTraza = [];
      this.markers = [];
      if (!this.form.traza) {
        this.pathRuta = [];
        this.pathPoli = [];
        return;
      }

      // Esperar a que termine la carga de GPS
      if (this.$parent.mapaPromise) {
        try {
          await this.$parent.mapaPromise;
        } catch (e) {
          // ignore
        }
      }
      if (!this.form.traza) {
        return;
      }

      const data = this.$parent.det_mapa;
      this.puntosTraza = Array.isArray(data) ? data : [];
      this.trazaViaje();
      await this.getRuta();
    },

    parseCoord(valor) {
      if (valor === null || valor === undefined || valor === "") {
        return NaN;
      }
      return parseFloat(String(valor).replace(",", "."));
    },

    trazaViaje() {
      if (this.puntosTraza.length > 0) {
        this.puntosTraza.forEach((loc1, index) => {
          const marker = {
            lat: this.parseCoord(loc1.latitud),
            lng: this.parseCoord(loc1.longitud),
          };
          const rotacion = getRotacionFlechaTraza(this.puntosTraza, index);

          const path = `
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="30">
                  <circle cx="13" cy="13.5" r="13" stroke="white" stroke-width="2" fill="#00529c"></circle>
                  <path 
                    fill="#b0c442"
                    stroke="white" 
                    stroke-width="1" 
                    d="M 7 7 L 13 11 L 19 7 L 13 21 Z" 
                    transform="rotate(${rotacion}, 13, 13)">
                  </path>
                  <rect width="39" height="15" fill="black" stroke="black" x="26" y="6"></rect>
                  <text font-size="10" font-family="" x="28" y="16" fill="white">
                    ${loc1.placa}
                  </text>
                </svg>
              `;
          const encodedPath = encodeURIComponent(path);
          const iconUrl = "data:image/svg+xml;charset=UTF-8," + encodedPath;

          let svgMarker = {
            url: iconUrl,
            fillColor: "#b0c442",
            fillOpacity: 1,
            strokeColor: "#00529c",
            strokeWeight: 1,
            strokeOpacity: 0.7,
            rotation: rotacion,
            scale: 0.7,
            // eslint-disable-next-line no-undef
            anchor: new google.maps.Point(15, 30),
          };

          this.markers.push({
            position: marker,
            icon: svgMarker,
            info: loc1.ventana,
            center: { marker },
            rotate: rotacion + 180,
          });
        });
       
        this.puntoInicialLat = this.parseCoord(this.puntosTraza[0].latitud);
        this.puntoInicialLng = this.parseCoord(this.puntosTraza[0].longitud);
        this.infoPuntoInicial = this.puntosTraza[0].ventana;

        this.markers.push({
          id: this.puntosTraza[0].id,
          position: {
            lat: this.puntoInicialLat,
            lng: this.puntoInicialLng,
          },
          icon: "/img/icon_punto_g_ok.png",
          info: this.infoPuntoInicial,
        });

        this.puntofin = this.puntosTraza.slice(-1);
        this.puntoFinalLat = this.parseCoord(this.puntofin[0].latitud);
        this.puntoFinalLng = this.parseCoord(this.puntofin[0].longitud);
        this.infoPuntoFinal = this.puntofin[0].ventana;

        this.markers.push({
          id: this.puntofin[0].id,
          position: {
            lat: this.puntoFinalLat,
            lng: this.puntoFinalLng,
          },
          icon: "/img/icon_punto_g.png",
          info: this.infoPuntoFinal,
        });

        const marker1 = {
          lat: this.puntoFinalLat,
          lng: this.puntoFinalLng,
        };
        this.center = marker1;
        this.zoomMapa = 15;
      } else {
        this.centrarBogota();
        // No alertar si aún hay una carga GPS en curso
        if (this.$parent.mapaCargando) {
          return;
        }
        this.$swal({
          title: "Tramas no encontradas!",
          text: "No se encontraron tramas para este viaje",
          icon: "warning",
        });
      }
    },

    async getNovedades() {
      this.path = [];
      this.markersAd = [];
      this.markersEm = [];
      this.$parent.cargando = true;
      let me = this;
      await axios
        .get("/api/hidrocarburos/reportenovedades/Mapa", {
          params: { viaje: this.$parent.viaje_id },
        })
        .then(async function(response) {
          me.markersAd = [];
          me.markersEm = [];

          const datosNovedades = response.data.advertencia;
          if (me.form.novedades == true) {
            await datosNovedades.forEach((nov) => {
              if (nov.latitud != null && nov.longitud != null) {
                const borderClass = nov.relevancia == 1 ? 'border-warning' : 'border-danger';
                const headerClass = nov.relevancia == 1 ? 'bg-warning text-dark' : 'bg-danger text-white';
                const badgeClass = nov.relevancia == 1 ? 'badge-warning' : 'badge-danger';
                let ventana =
                  '<div class="card ' + borderClass + '" style="min-width: 250px;">' +
                  '<div class="card-header ' + headerClass + '">' +
                  '<h5 class="card-title mb-0"><i class="fas fa-exclamation-triangle mr-2"></i>Vehículo: ' +
                  nov.vehiculo.placa +
                  '</h5></div>' +
                  '<div class="card-body">' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-calendar-alt mr-1"></i>Fecha:</strong> ' +
                  nov.fecha_novedad +
                  '</p>' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-route mr-1"></i>Viaje:</strong> ' +
                  nov.viaje_id +
                  '</p>' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-truck mr-1"></i>Transportadora:</strong> ' +
                  (nov.viaje.transportadora
                    ? nov.viaje.transportadora.razon_social
                    : "Sin asignar") +
                  '</p>' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-map-marker-alt mr-1"></i>Posición:</strong> ' +
                  nov.latitud +
                  ", " +
                  nov.longitud +
                  '</p>' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-tachometer-alt mr-1"></i>Velocidad:</strong> ' +
                  nov.velocidad +
                  ' Km/h</p>' +
                  '<hr>' +
                  '<p class="card-text mb-0"><strong><i class="fas fa-info-circle mr-1"></i>Novedad:</strong><br>' +
                  '<span class="badge ' + badgeClass + '">' +
                  nov.nTipoNovedad +
                  ' - ' +
                  nov.nSubNovedad +
                  '</span></p>' +
                  '</div></div>';
                const marker = {
                  lat: parseFloat(nov.latitud),
                  lng: parseFloat(nov.longitud),
                };
                me.markersAd.push({
                  position: marker,
                  icon: nov.relevancia == 2 ? me.crearIconoEmergencia() : me.crearIconoAdvertencia(),
                  info: ventana,
                  center: {
                    marker,
                  },
                });
              }
            });

            const datosNovedadesEmerg = response.data.emergencia;
            await datosNovedadesEmerg.forEach((nov) => {
              if (nov.latitud != null && nov.longitud != null) {
                const borderClass = nov.relevancia == 1 ? 'border-warning' : 'border-danger';
                const headerClass = nov.relevancia == 1 ? 'bg-warning text-dark' : 'bg-danger text-white';
                const badgeClass = nov.relevancia == 1 ? 'badge-warning' : 'badge-danger';
                let ventana =
                  '<div class="card ' + borderClass + '" style="min-width: 250px;">' +
                  '<div class="card-header ' + headerClass + '">' +
                  '<h5 class="card-title mb-0"><i class="fas fa-exclamation-circle mr-2"></i>Vehículo: ' +
                  nov.vehiculo.placa +
                  '</h5></div>' +
                  '<div class="card-body">' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-calendar-alt mr-1"></i>Fecha:</strong> ' +
                  nov.fecha_novedad +
                  '</p>' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-route mr-1"></i>Viaje:</strong> ' +
                  nov.viaje_id +
                  '</p>' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-truck mr-1"></i>Transportadora:</strong> ' +
                  (nov.viaje.transportadora
                    ? nov.viaje.transportadora.razon_social
                    : "Sin asignar") +
                  '</p>' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-map-marker-alt mr-1"></i>Posición:</strong> ' +
                  nov.latitud +
                  ", " +
                  nov.longitud +
                  '</p>' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-tachometer-alt mr-1"></i>Velocidad:</strong> ' +
                  nov.velocidad +
                  ' Km/h</p>' +
                  '<hr>' +
                  '<p class="card-text mb-0"><strong><i class="fas fa-info-circle mr-1"></i>Novedad:</strong><br>' +
                  '<span class="badge ' + badgeClass + '">' +
                  nov.nTipoNovedad +
                  ' - ' +
                  nov.nSubNovedad +
                  '</span></p>' +
                  '</div></div>';
                const marker = {
                  lat: parseFloat(nov.latitud),
                  lng: parseFloat(nov.longitud),
                };
                me.markersEm.push({
                  position: marker,
                  icon: nov.relevancia == 2 ? me.crearIconoEmergencia() : me.crearIconoAdvertencia(),
                  info: ventana,
                  center: {
                    marker,
                  },
                });
              }
            });
          }
          me.$parent.cargando = false;
        })
        .catch(function(error) {
          me.$parent.cargando = false;
          me.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    async getRutaGeocercas() {
      if (!this.form.rutaGeocercas) {
        this.polylinesRuta = {};
        if (!this.form.geocercas) {
          this.poligonos = [];
          this.circunferencias = [];
        }
        return;
      }

      const rutaId =
        (this.$parent.viaje && this.$parent.viaje.ruta_id) ||
        (this.$parent.viaje &&
          this.$parent.viaje.ruta &&
          this.$parent.viaje.ruta.id);

      if (!rutaId) {
        this.$swal({
          title: "Ruta no encontrada",
          text: "El viaje no tiene una ruta asociada",
          icon: "warning",
        });
        this.form.rutaGeocercas = false;
        return;
      }

      this.$parent.cargando = true;
      try {
        const response = await axios.get(
          "/api/admin/centralTrafico/rutasTramosMapaCalor",
          { params: { ruta_id: [rutaId] } }
        );
        if (!this.form.rutaGeocercas) {
          return;
        }
        const rutas = response.data?.data || [];
        this.dibujarRutaPorTramos(rutas);
        await this.getGeocercas();
      } catch (error) {
        this.polylinesRuta = {};
        this.form.rutaGeocercas = false;
        this.$swal({
          icon: "error",
          title: "Ocurrió un error al cargar la ruta: " + error,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } finally {
        this.$parent.cargando = false;
      }
    },

    dibujarRutaPorTramos(rutas) {
      const polylinesObj = {};
      let primerPunto = null;

      (rutas || []).forEach((ruta) => {
        const tramosRuta = ruta.rutas_tramos || [];

        tramosRuta.forEach((rutaTramo) => {
          const tramo = rutaTramo.tramo_ruta;
          if (!tramo || !tramo.det_tramos_rutas) {
            return;
          }

          const detallesOrdenados = [...tramo.det_tramos_rutas].sort((a, b) => {
            return (a.orden || 0) - (b.orden || 0);
          });

          const path = [];
          detallesOrdenados.forEach((detalle, index) => {
            const latIni = parseFloat(detalle.lat_ini);
            const lngIni = parseFloat(detalle.lon_ini);
            const latFin = parseFloat(detalle.lat_fin);
            const lngFin = parseFloat(detalle.lon_fin);

            if (
              Number.isNaN(latIni) ||
              Number.isNaN(lngIni) ||
              Number.isNaN(latFin) ||
              Number.isNaN(lngFin)
            ) {
              return;
            }

            if (index === 0) {
              path.push({ lat: latIni, lng: lngIni });
            }
            path.push({ lat: latFin, lng: lngFin });
          });

          if (path.length < 2) {
            return;
          }

          if (!primerPunto) {
            primerPunto = path[0];
          }

          const nombreRuta = ruta.nombre || "Ruta";
          const nombreTramo = tramo.nombre || "Tramo";
          const key = `ruta_${ruta.id}_tramo_${tramo.id}`;

          polylinesObj[key] = {
            path,
            options: {
              strokeColor: tramo.color || "#2563eb",
              strokeOpacity: 0.85,
              strokeWeight: 5,
            },
            info: `<div style="padding: 6px;">
              <strong>${nombreRuta}</strong><br>
              <span>${nombreTramo}</span>
            </div>`,
          };
        });
      });

      this.polylinesRuta = polylinesObj;

      if (Object.keys(polylinesObj).length === 0) {
        this.$swal({
          title: "Ruta sin tramos",
          text: "No se encontraron tramos para dibujar la ruta del viaje",
          icon: "warning",
        });
        return;
      }

      if (primerPunto) {
        this.center = primerPunto;
        this.zoomMapa = 10;
      }
    },

    async getGeocercas() {
      this.poligonos = [];
      this.circunferencias = [];
      this.$parent.cargando = true;
      let me = this;
      await axios
        .get("/api/hidrocarburos/mapas/showGeocercasRuta", {
          params: { viaje_id: this.$parent.viaje_id },
        })
        .then(async function(response) {
          me.poligonos = [];
          me.circunferencias = [];

          if (me.form.geocercas == true || me.form.rutaGeocercas == true) {
            const locations = response.data.gps_fin;
            
            // Procesar geocercas poligonales
            if (locations && locations.geocerca_poli) {
              await locations.geocerca_poli.forEach((geocerca) => {
                if (geocerca.puntos && geocerca.puntos.length > 0) {
                  let puntos = [];
                  geocerca.puntos.forEach((punto) => {
                    puntos.push({
                      lng: parseFloat(punto.longitud),
                      lat: parseFloat(punto.latitud),
                    });
                  });

                  me.poligonos.push({
                    id: geocerca.id,
                    name: geocerca.desc,
                    path: puntos,
                    info: geocerca.ventana,
                    color: geocerca.color,
                  });
                }
              });
            }

            // Procesar geocercas circulares
            if (locations && locations.geocerca_cir) {
              for (var j = 0; j < locations.geocerca_cir.length; j++) {
                if (locations.geocerca_cir[j]["lat"] !== "" && locations.geocerca_cir[j]["lat"] !== null) {
                  me.circunferencias.push({
                    center: {
                      lat: parseFloat(locations.geocerca_cir[j]["lat"]),
                      lng: parseFloat(locations.geocerca_cir[j]["lon"]),
                    },
                    radius: parseFloat(locations.geocerca_cir[j]["radio"]),
                    info: locations.geocerca_cir[j]["ventana"],
                    color: locations.geocerca_cir[j]["color"],
                  });
                }
              }
            }
          }
          me.$parent.cargando = false;
        })
        .catch(function(error) {
          me.$parent.cargando = false;
          me.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    async getRuta() {
      this.pathRuta = [];
      this.pathPoli = await this.$parent.det_ruta;
      if (this.pathPoli.length > 0) {
        for (let i = 0; i < this.pathPoli.length; i++) {
          if (i == 0) {
            this.pathRuta.push({
              lat: parseFloat(this.pathPoli[i].lat_ini),
              lng: parseFloat(this.pathPoli[i].lon_ini),
            });
          }
          this.pathRuta.push({
            lat: parseFloat(this.pathPoli[i].lat_fin),
            lng: parseFloat(this.pathPoli[i].lon_fin),
          });
        }
      }
    },

    toggleInfoWindow: function(marker, idx, ventana) {
      this.infoWindowPos = marker.position;
      this.infoContent = ventana;
      this.center = marker.position;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowPoli: function(poli, idx, ventana) {
      this.infoWindowPos = poli.path[0];
      this.infoContent = ventana;
      this.center = poli.path[0];

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowCir: function(cir, idx, ventana) {
      this.infoWindowPos = cir.center;
      this.infoContent = ventana;
      this.center = cir.center;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    generarListadoExcel() {
      let viaje_id = this.$parent.viaje_id;
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/viajes/trazaExport",
        data: { viaje_id },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  beforeDestroy() {
    this.limpiarMapa();
  },
};
</script>

<style scoped>
.map-container {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
}

.card-header {
  border-bottom: 2px solid rgba(0, 0, 0, 0.125);
}

.btn-group .btn {
  transition: all 0.3s ease;
}

.btn-group .btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.btn-group .btn:active {
  transform: translateY(0);
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .btn-toolbar {
    flex-direction: column;
  }
  
  .btn-group {
    width: 100%;
  }
  
  .btn-group .btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}

/* Info window styles */
::v-deep .gm-style-iw {
  padding: 0 !important;
}

::v-deep .gm-style-iw-d {
  overflow: hidden !important;
}

::v-deep .gm-style-iw-c {
  padding: 0 !important;
  border-radius: 4px !important;
}
</style>
